import React, { ReactNode } from 'react';
import { X } from 'lucide-react';
import './BaseWalkthrough.css';

export interface BaseWalkthroughProps {
  title: string;
  subtitle: string;
  onClose: () => void;
  children: ReactNode;
  className?: string;
  footer?: ReactNode;
}

const BaseWalkthrough: React.FC<BaseWalkthroughProps> = ({
  title,
  subtitle,
  onClose,
  children,
  className = '',
  footer,
}) => {
  return (
    <div className={`walkthrough-overlay ${className}`}>
      <div className="walkthrough-content">
        <button className="walkthrough-close" onClick={onClose} aria-label="Close">
          <X size={24} />
        </button>

        <h1 className="walkthrough-title">{title}</h1>
        <p className="walkthrough-subtitle">{subtitle}</p>

        <div className="walkthrough-body">
          {children}
        </div>

        {footer && (
          <div className="walkthrough-footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default BaseWalkthrough;
